/**
 * Прив’язка полів модуля «Персонал» до понять довідника (значок «?» біля підпису поля).
 * Ключ — `people.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапу підключає координатор у features/knowledge/fieldTerms.ts (FIELD_TERMS); поле в інтерфейсі:
 * <Field term="people.<сутність>.<поле>"> або <Property term="…">.
 */
export const PEOPLE_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Профіль працівника
  'people.profile.employmentType': 'ФОП',
  'people.profile.acknowledgements': 'Ознайомлення',
  'people.profile.training': 'Навчання',
  // Посади
  'people.position.jobFolderUrl': 'Посадова папка',
  'people.position.description': 'ЦКП',
  // Порушення, статистика й вплив
  'people.violation.report': 'Доповідь',
  'people.violation.stats': 'ІЦО',
  'people.violation.decision': 'Якість',
  'people.influence': 'Градієнт впливу',
  // Оцінка відповідності посаді
  'people.assessment': 'Атестація',
  'people.assessment.redTasks': 'Червона задача',
  // Мотивація
  'people.bonus.kpi': 'КРІ',
};
